import { ComponentFactoryResolver, Injector, ReflectiveInjector, ViewContainerRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { INDRAModalComponent } from '../modal.indra.component';
import scrollLock from 'scroll-lock';
import * as i0 from "@angular/core";
var MultipleModalService = /** @class */ (function () {
    function MultipleModalService(resolver) {
        this.resolver = resolver;
        this.activeInstances = 0;
        this.htmlElement = document.getElementsByTagName('html');
        this.modals = [];
    }
    MultipleModalService.prototype.registerViewContainerRef = function (vcRef) {
        this.vcRef = vcRef;
    };
    MultipleModalService.prototype.registerInjector = function (injector) {
        this.injector = injector;
    };
    MultipleModalService.prototype.create = function (component) {
        var _this = this;
        var parameters = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            parameters[_i - 1] = arguments[_i];
        }
        var componentRef$ = new ReplaySubject();
        var componentModalFactory = this.resolver.resolveComponentFactory(INDRAModalComponent);
        var componentFactory = this.resolver.resolveComponentFactory(component);
        var childInjector = ReflectiveInjector.resolveAndCreate([], this.injector);
        var componentRef = this.vcRef.createComponent(componentModalFactory, this.activeInstances, childInjector);
        setTimeout(function () {
            componentRef.instance.content = componentFactory.componentType;
            componentRef.instance.params = parameters;
            componentRef.instance.loadComponentMultiples();
        }, 10);
        this.activeInstances++;
        componentRef.instance['componentIndex'] = this.activeInstances;
        componentRef.instance['destroy'] = function () {
            _this.activeInstances--;
            componentRef.destroy();
            _this.prevModalLock();
        };
        this.modals.push(componentRef);
        componentRef$.next(componentRef);
        componentRef$.complete();
        return componentRef$.asObservable();
    };
    MultipleModalService.prototype.closeAll = function () {
        for (var _i = 0, _a = this.modals; _i < _a.length; _i++) {
            var modal = _a[_i];
            modal.destroy();
        }
        this.modals = [];
    };
    MultipleModalService.prototype.prevModalLock = function () {
        // Disable scroll on body
        if (this.activeInstances > 0) {
            if (!this.htmlElement[0].classList.contains('no-scroll'))
                this.htmlElement[0].classList.add('no-scroll');
            scrollLock.hide();
        }
    };
    MultipleModalService.ngInjectableDef = i0.defineInjectable({ factory: function MultipleModalService_Factory() { return new MultipleModalService(i0.inject(i0.ComponentFactoryResolver)); }, token: MultipleModalService, providedIn: "root" });
    return MultipleModalService;
}());
export { MultipleModalService };
